// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  'This certification was launched in the classic experience':
    'certs.classic.cert.label',
  'Open side panel': 'certs.open.side.panel',
  'This certification is no longer assigned to an active certifier.':
    'certs.no.active.certifier',
  'If the certification is not submitted by the due date, some access will be revoked automatically.':
    'certs.auto.revoke.warning',
  'Waiting for the primary certifier to submit the certification.':
    'certs.waiting.primary.certifier',
};
